var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Sidebar'),_c('div',[_vm._t("default")],2),_c('NotificationList'),_c('EcpUpdate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }